import {del, get, post, put} from "../helpers/api_helper";
import {ITgBot, ITgBotForm, ITgBotPagination} from "../store/tgBots/types";

export const TgBotsService = {
    getAll: async (filter: any): Promise<ITgBotPagination> => {
        return get("/telegram-bots", {params: filter})
    },

    getById: async (id: number): Promise<ITgBot> => {
        return get(`/telegram-bots/${id}`)
    },

    create: async (data: ITgBotForm) => {
        return post(`/telegram-bots`, data)
    },

    update: async (id: number, data: ITgBotForm) => {
        return put(`/telegram-bots/${id}`, data)
    },

    remove: async (id: number) => {
        return del(`/telegram-bots/${id}`)
    },
}